var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21315 6.00003H1.25806C0.843715 6.00003 0.508122 6.33563 0.508122 6.74997C0.508122 7.16432 0.843715 7.49991 1.25806 7.49991H3.43873L0.219336 10.7194C-0.0731121 11.0119 -0.0731121 11.4863 0.219336 11.7807C0.365691 11.9269 0.558747 12 0.749965 12C0.94118 12 1.13434 11.9269 1.28059 11.7807L4.49999 8.56127V10.7419C4.49999 11.1563 4.83559 11.4919 5.24993 11.4919C5.66427 11.4919 5.99987 11.1563 5.99987 10.7419L6 7.78685C6 6.80254 5.19746 6 4.21315 6L4.21315 6.00003Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78674 5.99996H10.7419C11.1563 5.99996 11.4919 5.66437 11.4919 5.25003C11.4919 4.83568 11.1563 4.50009 10.7419 4.50009L8.56117 4.49996L11.7807 1.28056C12.0731 0.988112 12.0731 0.513747 11.7807 0.219336C11.4882 -0.0731121 11.0118 -0.0731121 10.7194 0.219336L7.49992 3.43873V1.25806C7.49992 0.843715 7.16431 0.508122 6.74996 0.508122C6.3356 0.508122 6 0.843715 6 1.25806V4.21315C5.99987 5.19746 6.80243 6 7.78677 6L7.78674 5.99996Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeIcon);
export default __webpack_public_path__ + "static/media/minimize-icon.ff5c316aa6956d55dae4d8a738e60735.svg";
export { ForwardRef as ReactComponent };